import React, { useContext } from 'react';
import Proptypes from 'prop-types';
import {
  Card,
  CardBody,
  CardTitle,
  Typography,
} from '@one-thd/sui-atomic-components';
import { Note } from '@one-thd/sui-icons';
import { Document } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { SCREENS, TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const MODEL_NAME = 'starterListTile';

/**
 * Tile component for using starter lists
 */
export const StarterListTile = ({ isVertical = false }) => {
  const { setScreen } = useContext(AddToContext);
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const handleClick = () => {
    // 10.1 AI Entry Points - Track starter list entry point click
    triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
      entryPoint: SCREENS.STARTER_LISTS.toLocaleLowerCase().split('_').join(' ')
    });
    setScreen(SCREENS.STARTER_LISTS);
  };

  if (isVertical) {
    return (
      <div
        onClick={handleClick}
        role="presentation"
        data-testid="starter-list-tile"
        className="sui-w-full sui-mt-2"
      >
        <Card
          role="button"
          disablePadding
          disableGutters
          orientation="horizontal"
          aria-label="Use a starter list for common projects"
        >
          <div className="sui-w-24 sui-flex sui-justify-center sui-items-center">
            <Document size="large" color="primary" />
          </div>
          <div className="sui-py-3 sui-pr-1">
            <CardTitle
              header={(
                <Typography
                  variant="h3"
                  color="primary"
                >
                  Use a Starter List
                </Typography>
              )}
            />
            <CardBody>
              <Typography>
                Customize a template with your materials
              </Typography>
            </CardBody>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      data-testid="starter-list-tile"
      aria-label="Use a starter list for common projects"
      className="sui-h-full sui-flex sui-gap-2 sui-justify-center sui-items-center sui-cursor-pointer sui-paper-outlined sui-rounded-base sui-p-2"
    >
      <span className="sui-shrink-0 sui-flex sui-items-center">
        <Note size={isMobile ? 'small' : 'regular'} color="primary" />
      </span>
      <Typography variant={isMobile ? 'body-xs' : 'h6'} weight="bold">
        Use a starter list
      </Typography>
    </div>
  );
};

StarterListTile.propTypes = {
  isVertical: Proptypes.bool
};

StarterListTile.defaultProps = {
  isVertical: false
};

StarterListTile.displayName = 'StarterListTile';

export default StarterListTile;
